import React, { Component } from 'react';
import { 
  Accordion, 
  Grid, 
  GridColumn, 
  GridRow, 
  Icon,
} from 'semantic-ui-react';

export default class Faq extends Component {
  state = { activeIndex: 0 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

		const pStyle = {
			fontFamily: "'Lato', sans-serif",
			fontWeight: "400",
			color: "#FFFFFF",
			fontSize: "clamp(1.1em, 1vw, 1.4em)",
    	lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
		}

    return (
			<Grid style={{ padding: "0em 0em 10em 0em", margin: "0em" }}>
				<GridRow>
					<GridColumn textAlign='left' style={{ padding: "0em" }}>
						<Accordion>
							<Accordion.Title
								id="faq1"
								active={activeIndex === 0}
								index={0}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Can Custom Metal meet me at the job site/at home?
							</Accordion.Title>
							<Accordion.Content 
								id="faq1-content"
								active={activeIndex === 0}
							>
								<p style={pStyle}>
                  Yes, we like to offer on-site service to provide an easy service for the 
                  customer.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq2"
								active={activeIndex === 1}
								index={1}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Do you service areas outside of the Launceston area?
							</Accordion.Title>
							<Accordion.Content 
								id="faq2-content"
								active={activeIndex === 1}
							>
								<p style={pStyle}>
                  Yes, we provide services from the east coast to north coast and further 
                  upon request.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq3"
								active={activeIndex === 2}
								index={2}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Do you keep a stock of some of your projects (i.e. gates)?
							</Accordion.Title>
							<Accordion.Content 
								id="faq3-content"
								active={activeIndex === 2}
							>
								<p style={pStyle}>
                  No, we make every project to suit the application and space but we do keep 
                  a stock of commonly used materials and hardware to help with completing 
                  the project in a timely manner.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq4"
								active={activeIndex === 3}
								index={3}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								I am unsure of exactly what product/solution is required for this 
                application. Do I need to work that out before asking you for a product?
							</Accordion.Title>
							<Accordion.Content 
								id="faq4-content"
								active={activeIndex === 3}
							>
								<p style={pStyle}>
                  No, we are more than happy to work with you to come up with a solution with 
                  the optimal product for your requirements. At Custom Metal we have worked with a 
									lot of different products and can explain the benefits of each option for your 
                  application so you can come to an informed decision.
								</p>
							</Accordion.Content>
						</Accordion>
				  </GridColumn>
				</GridRow>
			</Grid>
    )
  }
}